import { colors, fontWeight } from 'seedling/constants';
import { borderRadius, baseHeight } from './consts';

export const dropdownDefaultStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: 'none',
    borderRadius: state.menuIsOpen
      ? `${borderRadius}px ${borderRadius}px 0 0`
      : borderRadius,
    borderColor: colors.lightGrey,
    fontWeight: fontWeight.normal,
    ':hover': {
      borderColor: colors.lightGrey,
    },
  }),
  option: (base, _state) => ({
    ...base,
    color: '#000',
    height: baseHeight,
  }),
  menu: (base, _state) => ({
    ...base,
    boxShadow: 'none',
    borderRadius: `0 0 ${borderRadius}px ${borderRadius}px`,
    border: `1px solid ${colors.lightGrey}`,
    borderTop: 0,
    marginBottom: '24px',
  }),
  menuList: (base, _state) => ({
    ...base,
    padding: 0,
  }),
  group: (base, _state) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 5,

    ':first-of-type': {
      paddingTop: 10,
    },

    ':last-of-type': {
      paddingBottom: 0,
    },
  }),
  valueContainer: (base, _state) => ({
    ...base,
    padding: '0 10px',
  }),
  multiValue: (base, _state) => ({
    ...base,
    backgroundColor: 'none',
    position: 'relative',
    ':first-of-type': {
      marginLeft: 0,
    },
  }),
  multiValueRemove: (base, _state) => ({
    ...base,
    position: 'absolute',
    paddingTop: 2,
    right: 5,
    top: 0,
    bottom: 0,
    color: colors.mediumGrey,
    ':hover': {
      background: 'none',
      cursor: 'pointer',
    },
  }),
  indicatorsContainer: (base, _state) => ({
    ...base,
    padding: '0px 8px',
  }),
  clearIndicator: (base, _state) => ({
    ...base,
    padding: '0',
  }),
  indicatorSeparator: (_base, _state) => ({
    display: 'none',
  }),
  groupHeading: (base, _state) => ({
    ...base,
    textTransform: 'none',
    fontSize: 14,
  }),
};

export const dropdownHideDisabledOptionStyles = {
  ...dropdownDefaultStyles,
  option: (base, state) =>
    Object.assign(
      { ...base, display: state.isDisabled ? 'none' : 'inherit' },
      dropdownDefaultStyles.option()
    ),
};

export const Theme = baseTheme => {
  return {
    borderRadius: borderRadius,
    colors: {
      ...baseTheme.colors,
      neutral20: colors.lightGrey,
      primary25: colors.babyBlue,
      primary50: colors.babyBlue,
      primary: colors.lighterGrey,
    },
    spacing: {
      ...baseTheme.spacing,
      controlHeight: baseHeight,
      menuGutter: 0,
    },
  };
};
